import { render, staticRenderFns } from "./course-books.vue?vue&type=template&id=4ad3a81f&lang=pug"
import script from "./course-books.vue?vue&type=script&lang=js"
export * from "./course-books.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports